<template>
  <Card :header="$t('users-impacted')">
    <template #card-body>
      <ApexLineChart
        :title="title"
        :graphData="userImpacted"
        :intervalTime="intervalTime"
        :colors="['#FEFCAC', '#28EFC9']"
      ></ApexLineChart>
    </template>
  </Card>
</template>
<script>
const map = {
  B: 'Browser Monitoring',
  C: 'Mobile Monitoring',
};
import Card from '@/rex-components/rex-card.vue';
import ApexLineChart from '@/components/charts/apex-line-chart.vue';
import graphQl from '@/services/graphQl';
import { mapGetters } from 'vuex';

export default {
  components: { Card, ApexLineChart },
  data() {
    return {
      userImpacted: [],
      title: {
        x: this.$t('time'),
        y: this.$t('no-of-users'),
      },
    };
  },
  methods: {
    async getData() {
      try {
        const {
          data: {
            data: {
              userImpacted: { userImpacted },
            },
          },
        } = await graphQl.query('queryGetUsersImpacted').params({
          condition: {
            entity: {
              scope: 'All',
            },
          },
          duration: this.getDurationTime,
        });
        if (userImpacted && Array.isArray(userImpacted)) {
          this.userImpacted = userImpacted.map((ele) => {
            ele.name = map[ele.capability];
            return ele;
          });
        }
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    getDurationTime(newValue) {
      this.getData();
    },
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
  },
};
</script>
<style lang="scss"></style>
